var firebaseConfig = {
  apiKey: "AIzaSyDxBJRZEhYANMQrcmy-egITSHhJTyhFn14",
  authDomain: "bcproject-e074d.firebaseapp.com",
  databaseURL: "https://bcproject-e074d.firebaseio.com",
  projectId: "bcproject-e074d",
  storageBucket: "myapp-project-123.appspot.com",
  messagingSenderId: "234496639875"
};

var env_config = {}

if(process.env.NODE_ENV == 'devlocal'){
  console.log("Run in local dev")
  env_config.url_api_root = "http://localhost:5001/bcproject-e074d/us-central1/api/"
} else {
  console.log("Run in prod")
  env_config.url_api_root = "https://bc-scanner.de/api/"  
}

module.exports = {
  firebaseConfig,
  env_config
}

